export default "__VITE_ASSET__d046d369__"